export default "__VITE_ASSET__orCAKVAL__"